import { formInput, UseLinePropertiesFilter } from './hooks/lineItem.hooks'

export const LineItemNotes = ({ properties, useLinePropertiesFilter: filter }: {properties: formInput[], useLinePropertiesFilter: UseLinePropertiesFilter }) => {
    return (<>
        {
            properties.filter(p => p.field == 'notes').map(p => p.Component)
        }
    </>);
}